import { render, staticRenderFns } from "./PriceExtinguisher.vue?vue&type=template&id=27a3501d&scoped=true&"
import script from "./PriceExtinguisher.vue?vue&type=script&lang=js&"
export * from "./PriceExtinguisher.vue?vue&type=script&lang=js&"
import style0 from "./PriceExtinguisher.vue?vue&type=style&index=0&id=27a3501d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a3501d",
  null
  
)

export default component.exports